import { toHump ,toLine } from '../utils/Conversion';
import * as R from 'ramda';

export const handler = {
    get: (target: any, key: string): any => {
      if (key in target) {
          if (R.type(target[key])=== 'Array') {
            return target[key].map((item: any) => apiListProxy(item))
          }
          return target[key]
        }
  
        const keyNames = Object.keys(target).map(name => toHump(name))
    
        if (keyNames.indexOf(key) !== -1)  {
          if (R.type(target[toLine(key)]) === 'Array') {
            return target[toLine(key)].map((item: any) => apiListProxy(item))
          }
  
         return target[toLine(key)]
        }
    
        return null
    
    }
}

export default function apiListProxy (target: any) {
  if (typeof target !== 'object' ) return target
    return new Proxy(target, handler)
}





